import { SortOrder, SortType } from '@fullstory/proto/fs/api/metrics';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { AuditEvent, ObjectDetails, ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { bytes, int64, Timestamp, timestamp } from '@fullstory/proto/google/protobuf';

export const makeMockObjectDetails = (id: string, name: string): ObjectDetails => ({
  objectId: id,
  objectType: 'METRIC',
  objectViewCount: int64.fromNumber(0),
  objectName: name,
  archived: false,
  createdBy: 'User',
  lastUpdated: '2021-08-25T20:00:00.000Z' as timestamp,
  metric: {
    canned: false,
    starred: false,
    lastViewed: '2021-08-25T20:00:00.000Z' as timestamp,
    metric: {
      isCanned: false,
      isDcmCreated: false,
      metadata: {
        archived: false,
        visibility: Visibility.PUBLIC,
        created: '2021-08-25T20:00:00.000Z' as timestamp,
        createdBy: 'User',
        lastUpdated: '2021-08-25T20:00:00.000Z' as timestamp,
        lastUpdatedBy: 'User',
        sequentialVersion: '1' as int64,
        version: '1' as int64,
      },
      metric: {
        name,
        description: 'Description',
        id,
        funnelFilter: null,
        trend: {
          frequency: 1,
          computePast: false,
          segmentId: [],
          conversionId: [],
          displayAs: {
            displayPrecision: 1,
            number: true,
          },
          timeRange: {
            startTime: 'NOW/DAY-29DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          segment: [
            {
              segmentId: 'everyone',
              segmentScope: 3,
            },
          ],
          dimensionSettings: {
            dimension: null,
            dimensions: [],
            sortOrder: SortOrder.SORT_ORDER_DESC,
            sortByDefault: false,
            sortType: SortType.SORT_TYPE_INVALID,
            limit: 50,
            computeTopLevel: false,
            computeNumGroups: false,
            allowAllPartialResults: false,
            noFallback: false,
          },
          timeRangeComparison: null,
          color: 0,
        },
        metric: {
          single: {
            event: {
              primary: {
                click: {
                  withElementId: {
                    value: ['03rVX64vFXhn'],
                    spec: [],
                  },
                },
              },
              deps: [],
            },
            aggregation: {
              unique: 1,
            },
            rollingWindow: 0,
            rollingWindowType: 0,
            rollingWindowInterval: 0,
          },
        },
      },
    },
  },
});

export const data: AuditEvent[] = [
  {
    id: '1',
    orgId: 'testOrgId',
    hashId: '1',
    changeType: 'Watched rule applied',
    changeBy: 'Supercalifragilisticexpialidocious@asuperlongemaildomain.com',
    when: Timestamp.fromDate(new Date(2023, 10, 23)),
    changeTargetId: '',
    changeTargetType: ObjectType.ELEMENT.toString(),
    changeValue: '',
    updatedState: bytes.fromString('updated state'),
  },
  {
    id: '2',
    orgId: 'testOrgId',
    hashId: '2',
    changeType: 'Selector removed',
    changeBy: 'user2@example.com',
    when: Timestamp.fromDate(new Date(2023, 10, 22)),
    changeTargetId: '',
    changeTargetType: ObjectType.ELEMENT.toString(),
    changeValue: 'selector removed change',
    updatedState: bytes.fromString('updated state'),
  },
  {
    id: '3',
    orgId: 'testOrgId',
    hashId: '3',
    changeType: 'Selector added',
    changeBy: 'user3@example.com',
    when: Timestamp.fromDate(new Date(2023, 10, 21)),
    changeTargetId: '',
    changeTargetType: ObjectType.ELEMENT.toString(),
    changeValue: 'selector added change',
    updatedState: bytes.fromString('updated state'),
  },
  {
    id: '4',
    orgId: 'testOrgId',
    hashId: '4',
    changeType: 'Issue snoozed',
    changeBy: 'user4@example.com',
    when: Timestamp.fromDate(new Date(2023, 10, 20)),
    changeTargetId: '',
    changeTargetType: ObjectType.ELEMENT.toString(),
    changeValue: '',
    updatedState: bytes.fromString('updated state'),
  },
  {
    id: '5',
    orgId: 'testOrgId',
    hashId: '5',
    changeType: 'Issue raised',
    changeBy: 'user5@example.com',
    when: Timestamp.fromDate(new Date(2023, 10, 20)),
    changeTargetId: '',
    changeTargetType: ObjectType.ELEMENT.toString(),
    changeValue: '',
    updatedState: bytes.fromString('updated state'),
  },
];
